var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"side",attrs:{"src":require(("@/assets/" + _vm.img)),"alt":"member.png"}}),_c('div',{staticClass:"side"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.desc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }